var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 2.91663H5.83366C3.33366 2.91663 1.66699 4.16663 1.66699 7.08329V12.9166C1.66699 15.8333 3.33366 17.0833 5.83366 17.0833H14.167C16.667 17.0833 18.3337 15.8333 18.3337 12.9166V7.08329C18.3337 4.16663 16.667 2.91663 14.167 2.91663ZM14.5587 7.99163L11.9503 10.075C11.4003 10.5166 10.7003 10.7333 10.0003 10.7333C9.30033 10.7333 8.59199 10.5166 8.05033 10.075L5.44199 7.99163C5.17533 7.77496 5.13366 7.37496 5.34199 7.10829C5.55866 6.84163 5.95033 6.79163 6.21699 7.00829L8.82533 9.09163C9.45866 9.59996 10.5337 9.59996 11.167 9.09163L13.7753 7.00829C14.042 6.79163 14.442 6.83329 14.6503 7.10829C14.867 7.37496 14.8253 7.77496 14.5587 7.99163Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.0ab71a49b5f916184471e19e9318f0d9.svg";
export { ForwardRef as ReactComponent };